// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"Gi-z","categoryName":"Hi-z","categoryImage":"Ii-z","categoryContent":"Ji-z","bottomAligned":"Ki-z"};